import async from 'async';
import * as actionTypes from '../constants/actionTypes';
import * as webService from '../services/webService';

const  receiveContact = (payload) =>({
    type:actionTypes.RECEIVE_CONTACT,
    payload

})
const  receiveForm = (payload) =>({
    type:actionTypes.RECEIVE_FORM,
    payload

})

export const getContactDataInit = (dispatch) => {
    return new Promise ((resolve,failure)=>{
        async.series([
             (cb)=> {
                webService.getContact().then((res)=>{
                    if(res.data.success){
                        cb (null,res.data.success)

                    }else {
                        cb(null,false)
                    }
                })
                    .catch((err)=>{
                        cb(null,false)
                    })


        }
        ], (err,result)=>{
            dispatch(receiveContact(result[0]));
            resolve(result)
            }
        )

    })
}
export const getFormDataInit = (dispatch) => {
    return new Promise ((resolve,reject)=>{
        async.series([
             (cb)=> {
                webService.getForm().then((res)=>{
                    if(res.data.success){
                        cb (null,res.data.success)

                    }else {
                        cb(null,false)
                    }
                })
                    .catch((err)=>{
                        cb(null,false)
                    })


        }
        ], (err,result)=>{
            dispatch(receiveForm(result[0]));
            resolve(result)
            }
        )

    })
}